var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{staticClass:"fill-height d-flex justify-center align-center",attrs:{"fluid":""}},[_c('div',{staticClass:"success-container"},[_c('div',{staticClass:"success-icon"}),_c('h1',[_vm._v("Başarıyla Kaydedildi!")]),_c('p',[_vm._v("Form başvurunuz başarıyla alınmıştır.")]),_vm._v(" "+_vm._s(_vm.getId)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }